import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import blogImage from "../assets/article_img.webp";
import blogImage1 from "../assets/post_4_img.webp";
import blogImage2 from "../assets/post_3_img.webp";
import blogImage3 from "../assets/post_2_img.webp";
import blogImage4 from "../assets/post_1_img.webp";
import sk from "../assets/sk.jpeg";
import Footer from "./Footer";
import Navbar from "./Navbar";

function BlogArticlePage() {
  const blogPosts = [
    {
      id: 1,
      category: "Loan for Travel",
      title: "How to Spend the Perfect Day on Croatia's Most Magical Island",
      author: "Kumar Shivam",
      date: "July, 2024",
      views: 35,
      excerpt:
        "Explore expert tips for a stress-free cross-country transition for your furry friends. Learn how to ease their journey and make the move a positive experience.",
      content:
        "Upon arrival, your senses will be rewarded with the pleasant scent of lemongrass oil used to clean the natural wood found throughout the room, creating a relaxing atmosphere within the space. A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the charm of existence in this spot, which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite.",
      likes: 35,
      tagline: "Don't wait. The purpose of our lives is to be happy!",
    },
    {
      id: 2,
      category: "Loan for Travel",
      title: "Hidden Gems: 10 Unexplored Destinations in Southeast Asia",
      author: "Priya Sharma",
      date: "August, 2024",
      views: 42,
      excerpt:
        "Discover the secret locations that tourists haven't found yet. Authentic experiences await in these pristine Southeast Asian locations.",
      content:
        "Far from the crowded tourist spots, these hidden destinations offer authentic cultural experiences and breathtaking landscapes that remain largely untouched. Local cuisine, traditional hospitality, and pristine natural environments make these spots truly special for the adventurous traveler seeking genuine connections with places and people.",
      likes: 47,
      tagline: "Adventure awaits in the places less traveled!",
    },
    {
      id: 3,
      category: "Budget Travel",
      title: "How to Travel Europe for a Month on Just $2000",
      author: "Vikram Patel",
      date: "June, 2024",
      views: 89,
      excerpt:
        "Budget travel doesn't mean missing out. Learn how to experience all Europe has to offer while keeping costs remarkably low.",
      content:
        "Smart planning and local insights can transform your European adventure from an expensive dream to an affordable reality. From hostel strategies to transportation hacks, meal planning to free attractions, this comprehensive approach ensures you experience the richness of European culture without emptying your bank account.",
      likes: 103,
      tagline: "Travel more, spend less, experience everything!",
    },
  ];

  const moreAuthorPosts = [
    {
      image: blogImage1,
      text: "Inspiring stories and practical tips for your next journey. Discover the unknown.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
    {
      image: blogImage2,
      text: "Budget-friendly destinations that don't compromise on experience. Travel smarter.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
    {
      image: blogImage3,
      text: "Cultural immersion: How to truly experience local life when traveling abroad.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
    {
      image: blogImage4,
      text: "Essential packing tips for different travel styles and destinations worldwide.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
    {
      image: blogImage1,
      text: "Sustainable travel: Minimizing your carbon footprint while exploring the world.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
    {
      image: blogImage2,
      text: "Solo travel guide: Finding confidence and connection when traveling alone.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
    {
      image: blogImage3,
      text: "Photography essentials: Capturing memories that last beyond your journey.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
    {
      image: blogImage4,
      text: "Essential packing tips for different travel styles and destinations worldwide.",
      author: "Kumar Shivam",
      authorImg: sk,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSliding, setIsSliding] = useState(false);
  const [slideDirection, setSlideDirection] = useState(null);
  const sliderRef = useRef(null);

  const handleNavigation = (direction) => {
    if (isSliding) return;

    setIsSliding(true);
    setSlideDirection(direction);

    if (direction === "previous") {
      setCurrentIndex((prev) => (prev === 0 ? blogPosts.length - 1 : prev - 1));
    } else {
      setCurrentIndex((prev) => (prev === blogPosts.length - 1 ? 0 : prev + 1));
    }

    setTimeout(() => {
      setIsSliding(false);
    }, 500);
  };

  const currentPost = blogPosts[currentIndex];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .slide-container {
        position: relative;
        overflow: hidden;
      }
      
      .blog-slide {
        transition: transform 0.5s ease-in-out;
      }
      
      .sliding-previous {
        animation: slideFromLeft 0.5s forwards;
      }
      
      .sliding-next {
        animation: slideFromRight 0.5s forwards;
      }
      
      @keyframes slideFromLeft {
        from { transform: translateX(-100%); }
        to { transform: translateX(0); }
      }
      
      @keyframes slideFromRight {
        from { transform: translateX(100%); }
        to { transform: translateX(0); }
      }
      
      .sliding-out-previous {
        animation: slideToRight 0.5s forwards;
      }
      
      .sliding-out-next {
        animation: slideToLeft 0.5s forwards;
      }
      
      @keyframes slideToRight {
        from { transform: translateX(0); }
        to { transform: translateX(100%); }
      }
      
      @keyframes slideToLeft {
        from { transform: translateX(0); }
        to { transform: translateX(-100%); }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <div className="main-box-8 mt-lg-5">
        <div className="container">
          <div
            className="row justify-content-center align-items-center text-center"
            style={{ minHeight: "45vh" }}
          >
            <div className="col-12 mb-3"></div>

            <div className="col-12 slide-container">
              <div
                ref={sliderRef}
                className={`blog-slide ${
                  isSliding
                    ? slideDirection === "previous"
                      ? "sliding-previous"
                      : "sliding-next"
                    : ""
                }`}
              >
                  <div className="row mt-5">
                    <div className="col-12 col-md-6 mb-4 p-4">
                      <div className="custom bg-white rounded ">
                        <div className="w-100 text-start">
                          <button
                            className="btn mt-3 text-start mb-3 rounded-pill"
                            style={{ backgroundColor: "#D9D9D9" }}
                          >
                            {currentPost.category}
                          </button>
                        </div>

                        <h5 className="fw-bold text-start mt-3">
                          {currentPost.title}
                        </h5>
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-4 text-muted">
                          <p className="mb-2 mb-sm-0">
                            <strong>By {currentPost.author}</strong>
                          </p>
                          <p className="mb-0 small">
                            <i className="bi bi-calendar me-1"></i>{" "}
                            {currentPost.date}
                            <i className="bi bi-eye ms-2 me-1"></i>{" "}
                            {currentPost.views} views
                            <i className="bi bi-share ms-2"></i> share
                          </p>
                        </div>

                        <p className="text-start mt-4 mt-md-5">
                          {currentPost.excerpt}
                        </p>

                        <img
                          src={blogImage}
                          className="img-fluid rounded my-3 w-100"
                          alt="Blog Visual"
                        />

                        <h5 className="text-start">{currentPost.tagline}</h5>
                        <p className="mt-4 mt-md-5 text-start">
                          {currentPost.content}
                        </p>

                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                          <div className="d-flex align-items-center gap-3 mt-4">
                            <button
                              className="btn btn-primary d-flex align-items-center gap-2 px-3 py-1"
                              style={{ borderRadius: "5rem" }}
                            >
                              <i className="bi bi-hand-thumbs-up"></i> Likes:{" "}
                              {currentPost.likes}
                            </button>
                          </div>

                          <button className="btn btn-sm rounded-pill mt-3 mt-sm-0">
                            <i className="bi bi-share me-1"></i> Share
                          </button>
                        </div>

                        <div className="mt-4">
                          <h5 className="text-start">Popular Searches</h5>
                          <div className="bade text-start">
                            <div className="d-flex flex-wrap gap-2 mt-5">
                              <span className="badge bg-white text-dark border border-dark px-3 py-2 rounded-pill">
                                Bestest Place in India
                              </span>
                              <span className="badge bg-white text-dark border border-dark px-3 py-2 rounded-pill">
                                Travel Loan
                              </span>
                              <span className="badge bg-white text-dark border border-dark px-3 py-2 rounded-pill">
                                Trips
                              </span>
                              <span className="badge bg-white text-dark border border-dark px-3 py-2 rounded-pill">
                                Top Rates Travel Loan
                              </span>
                              <span className="badge bg-white text-dark border border-dark px-3 py-2 rounded-pill">
                                Tax Benefits on Travel Loan
                              </span>
                              <span className="badge bg-white text-dark border border-dark px-3 py-2 rounded-pill">
                                Loan Under 10 Lakh
                              </span>
                              <span className="badge bg-white text-dark border border-dark px-3 py-2 rounded-pill">
                                Easy Loan
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 p-4 mt-3">
                      <div
                        className="rounded h-100"
                        style={{ backgroundColor: "#DFEBFF" }}
                      >
                        <h4 className="mb-5 pt-4 fw-semibold text-center m-0 fs-5">
                          More from Author
                        </h4>

                        {moreAuthorPosts.map((post, index) => (
                          <div
                            className="row g-2 align-items-center"
                            key={index}
                            style={{ margin: "20px" }}
                          >
                            <div className="col-4 col-sm-4 col-md-5 col-lg-4">
                              <img
                                src={post.image}
                                className="img-fluid rounded"
                                alt="Blog Visual"
                                style={{
                                  width: "fit-content",
                                  height: "auto",
                                  maxHeight: "100px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div className="col-8 col-sm-8 col-md-7 col-lg-8 d-flex flex-column justify-content-center">
                              <p className="mb-1 text-start small">
                                {post.text}
                              </p>
                              <div className="d-flex align-items-center gap-2 ">
                                <img
                                  src={post.authorImg}
                                  alt="Profile"
                                  width="25"
                                  height="25"
                                  style={{
                                    objectFit: "cover",
                                    borderRadius: "50%",
                                  }}
                                />
                                <span className="text-start small fw-semibold text-silver">
                                  {post.author}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                
              </div>
            </div>

            <div className="col-12">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex gap-3 justify-content-start mt-4 mb-5 flex-wrap">
                      <button
                        className="btn bg-primary text-white rounded-pill d-flex align-items-center px-4"
                        onClick={() => handleNavigation("previous")}
                        disabled={isSliding}
                      >
                        <i className="bi bi-arrow-left me-2"></i> Previous
                      </button>

                      <button
                        className="btn bg-primary text-white rounded-pill d-flex align-items-center px-4"
                        onClick={() => handleNavigation("next")}
                        disabled={isSliding}
                      >
                        Next <i className="bi bi-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogArticlePage;